import { render, staticRenderFns } from "./WIcon.vue?vue&type=template&id=3db281e6&scoped=true"
import script from "./WIcon.vue?vue&type=script&lang=js"
export * from "./WIcon.vue?vue&type=script&lang=js"
import style0 from "./WIcon.vue?vue&type=style&index=0&id=3db281e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db281e6",
  null
  
)

export default component.exports